"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressStepperMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _ProgressBar = require("../../components/ProgressBar/ProgressBar.styles");
var _ProgressStepperCurrentLabel = require("../../components/ProgressStepperCurrentLabel/ProgressStepperCurrentLabel.styles");
var _ProgressStepperStep = require("../../components/ProgressStepperStep/ProgressStepperStep.styles");
var _ProgressStepperStepLabel = require("../../components/ProgressStepperStepLabel/ProgressStepperStepLabel.styles");
var _ProgressStepperStepLabelText = require("../../components/ProgressStepperStepLabelText/ProgressStepperStepLabelText.styles");
var _constants = require("../../constants");
var _inlineMediaQueryMixin = require("../inlineMediaQueryMixin");
var _spaceMixin = require("../spaceMixin");
var _spacingMixin = require("../spacingMixin");
var calcStepWidth = function calcStepWidth(length) {
  return 1 / length * 100;
};
var currentStepLabelCSS = function currentStepLabelCSS(props) {
  var length = props.length;
  return (0, _styledToken.default)({
    fontWeight: 'ProgressStepper.label.fontWeight.current',
    nonInteractiveStepSize: 'ProgressStepper.nonInteractiveStepSize'
  }, function (_ref) {
    var fontWeight = _ref.fontWeight,
      nonInteractiveStepSize = _ref.nonInteractiveStepSize;
    return (0, _styledComponents.css)(["", "{padding:", " calc(", "% - ", "px) 0;", "{font-weight:", ";}}"], _ProgressStepperCurrentLabel.StyledProgressStepperCurrentLabel, (0, _spaceMixin.spaceMixin)('xs')(props), calcStepWidth(length) / 2, nonInteractiveStepSize, _ProgressStepperStepLabelText.StyledProgressStepperStepLabelText, fontWeight);
  })(props);
};
var progressBarCSS = function progressBarCSS(props) {
  var length = props.length;
  return (0, _styledToken.default)({
    backgroundColor: 'ProgressStepper.backgroundColor',
    indicatorColor: 'ProgressStepper.indicatorColor',
    currentStepSize: 'ProgressStepper.currentStepSize',
    nonInteractiveStepSize: 'ProgressStepper.nonInteractiveStepSize',
    progressBarHeight: 'ProgressMeter.sizes.sm'
  }, function (_ref2) {
    var backgroundColor = _ref2.backgroundColor,
      indicatorColor = _ref2.indicatorColor,
      currentStepSize = _ref2.currentStepSize,
      nonInteractiveStepSize = _ref2.nonInteractiveStepSize,
      progressBarHeight = _ref2.progressBarHeight;
    return (0, _styledComponents.css)(["", "{position:absolute;top:", "px;left:calc(", "% - ", "px);width:calc(", "% + ", "px);background-color:", ";&::before{background-color:", ";}}"], _ProgressBar.StyledProgressBar, (currentStepSize - progressBarHeight) / 2, calcStepWidth(length) / 2, nonInteractiveStepSize, 100 - calcStepWidth(length), nonInteractiveStepSize * 2, backgroundColor, indicatorColor);
  })(props);
};
var stepWidthCSS = function stepWidthCSS(props) {
  var length = props.length;
  return (0, _styledComponents.css)(["", "{width:", "%;}"], _ProgressStepperStep.StyledProgressStepperStep, calcStepWidth(length));
};
var labelAppearanceCSS = function labelAppearanceCSS(mediaProps) {
  var labelAppearance = mediaProps.labelAppearance,
    orientation = mediaProps.orientation;
  if (labelAppearance === _constants.PROGRESS_STEPPER_LABEL_APPEARANCES.NONE) {
    return (0, _styledComponents.css)(["", "{display:none;}"], _ProgressStepperStepLabel.StyledProgressStepperStepLabel);
  }
  if (labelAppearance === _constants.PROGRESS_STEPPER_LABEL_APPEARANCES.CURRENT && orientation !== _constants.ORIENTATIONS.vertical) {
    return (0, _styledComponents.css)(["", " > ", "{display:none;}", "{display:initial;}"], _ProgressStepperStep.StyledProgressStepperStep, _ProgressStepperStepLabel.StyledProgressStepperStepLabel, _ProgressStepperCurrentLabel.StyledProgressStepperCurrentLabel);
  }
  return (0, _styledComponents.css)(["", " > ", "{display:initial;}", "{display:none;}"], _ProgressStepperStep.StyledProgressStepperStep, _ProgressStepperStepLabel.StyledProgressStepperStepLabel, _ProgressStepperCurrentLabel.StyledProgressStepperCurrentLabel);
};
var leftAlignCSS = function leftAlignCSS(props) {
  var alignLabels = props.alignLabels,
    length = props.length;
  if (alignLabels !== _constants.PROGRESS_STEPPER_LABEL_ALIGNMENTS.LEFT) {
    return '';
  }
  return (0, _styledToken.default)({
    nonInteractiveStepSize: 'ProgressStepper.nonInteractiveStepSize'
  }, function (_ref3) {
    var nonInteractiveStepSize = _ref3.nonInteractiveStepSize;
    return (0, _styledComponents.css)(["", "{padding-left:0;&:nth-child(2){margin-left:calc(", "% - ", "px);}&:nth-child(", "){width:", "%;}}"], _ProgressStepperStep.StyledProgressStepperStep, calcStepWidth(length) / 2, nonInteractiveStepSize, length + 1, calcStepWidth(length) / 2);
  });
};
var orientationCSS = function orientationCSS(props) {
  var labelAppearance = props.labelAppearance,
    length = props.length,
    orientation = props.orientation;
  if (orientation !== _constants.ORIENTATIONS.vertical) {
    return '';
  }
  return (0, _styledToken.default)({
    interactiveStepSize: 'ProgressStepper.interactiveStepSize',
    labelTextLineHeight: 'ProgressStepper.label.lineHeight',
    progressBarWidth: 'ProgressMeter.sizes.sm',
    stepPaddingX: 'ProgressStepper.stepPaddingX'
  }, function (_ref4) {
    var interactiveStepSize = _ref4.interactiveStepSize,
      labelTextLineHeight = _ref4.labelTextLineHeight,
      progressBarWidth = _ref4.progressBarWidth,
      stepPaddingX = _ref4.stepPaddingX;
    return (0, _styledComponents.css)(["display:grid;grid-template-rows:repeat(", ",minmax(10px,1fr)) auto;", "{top:", "px;left:", "px;width:", "px;grid-row:1 / ", ";height:calc(100% + ", "px);}", "{width:auto;padding-left:", "px;&:nth-child(2){margin-left:0;}&:nth-child(", "){width:auto;}}", " > ", "{display:", ";}", "{display:none;}"], length - 1, _ProgressBar.StyledProgressBar, (labelTextLineHeight - progressBarWidth) / 2, (interactiveStepSize - progressBarWidth) / 2 + stepPaddingX, progressBarWidth, length, progressBarWidth, _ProgressStepperStep.StyledProgressStepperStep, stepPaddingX, length + 1, _ProgressStepperStep.StyledProgressStepperStep, _ProgressStepperStepLabel.StyledProgressStepperStepLabel, labelAppearance === _constants.PROGRESS_STEPPER_LABEL_APPEARANCES.NONE ? 'none' : 'initial', _ProgressStepperCurrentLabel.StyledProgressStepperCurrentLabel);
  });
};

/** @class ProgressStepperMixin */
/** @method */
var ProgressStepperMixin = function ProgressStepperMixin(props) {
  return (0, _styledToken.default)({
    currentStepSize: 'ProgressStepper.currentStepSize'
  }, function (_ref5) {
    var currentStepSize = _ref5.currentStepSize;
    return (0, _styledComponents.css)(["position:relative;display:flex;flex-wrap:wrap;min-height:", "px;", " ", " ", " ", " ", " ", " ", ""], currentStepSize, currentStepLabelCSS(props), progressBarCSS(props), stepWidthCSS(props), leftAlignCSS(props), (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('labelAppearance', labelAppearanceCSS)(props), (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('orientation', orientationCSS)(props), (0, _spacingMixin.spacingMixin)(props));
  })(props);
};
exports.ProgressStepperMixin = ProgressStepperMixin;